module.exports = __webpack_public_path__ + "img/code.6ee841dc.png";